"use client";

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { ICampaignSimpleMessage } from "@/interfaces/campaign-simple-message.interface";
import campaignSimpleMessageService from "@/services/campaign-simple-message.service";
import { RequestsBaseReturn } from "@/types/requests.types";

export type UseGetCampaignSimpleMessageByIdReturn =
  RequestsBaseReturn<ICampaignSimpleMessage | null>;

interface UseGetCampaignSimpleMessageByIdProps {
  _id: number;
}

type UseSwrGetCampaignSimpleMessageByIdParams = [string, number];

const useGetCampaignSimpleMessageById = ({
  _id,
}: UseGetCampaignSimpleMessageByIdProps): UseGetCampaignSimpleMessageByIdReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<ICampaignSimpleMessage | null, Error, UseSwrGetCampaignSimpleMessageByIdParams | null>(
    _id ? [SWR_KEYS.getCampaignSimpleMessageById, _id] : null,
    async ([, id]) => {
      const result = await campaignSimpleMessageService.getByCampaignId(id);
      return result;
    },
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetCampaignSimpleMessageById;
